import React from 'react';
import { Route, Switch } from 'react-router-dom';
import P, { InferProps } from 'prop-types';
import PollsList from './polls-list';

function Polls({ match }: InferProps<typeof Polls.propTypes>) {
  return (
    <Switch>
      <Route exact path={`${match.url}/:abbrv`} component={PollsList} />
    </Switch>
  );
}

Polls.propTypes = {
  match: P.shape({
    url: P.string.isRequired,
  }).isRequired,
};

export default Polls;
